/** منبع واحد نسخه محصول — با package.json همگام نگه دارید */
export const APP_VERSION = '2.1.0';
export const APP_VERSION_LABEL = 'نسخه ۲.۱';
export const APP_VERSION_BADGE = 'v2.1';
export const APP_RELEASE_DATE = '۸ شهریور ۱۴۰۵';

/** @deprecated از APP_VERSION_BADGE استفاده کنید */
export const HEADER_VERSION_BADGE = APP_VERSION_BADGE;
